"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bundle_1 = __importDefault(require("./registry/Bundle"));
const Container_1 = __importDefault(require("./container/Container"));
const CustomProvider_1 = __importDefault(require("./container/CustomProvider"));
const Logger_1 = require("./utils/Logger");
const BUNDLE = Symbol('bundle');
class OdinCore {
    constructor() {
        this[BUNDLE] = new Bundle_1.default('odin');
    }
    bundle(domain, create = true) {
        let bundle = this[BUNDLE];
        if (domain) {
            if (domain !== domain.trim()) {
                (0, Logger_1.error)(`Invalid domain '${domain}'.`);
            }
            const path = domain.toLowerCase().split('/');
            bundle = path.reduce((b, p) => {
                if (p !== p.trim()) {
                    (0, Logger_1.error)(`Invalid sub domain '${p}' on domain '${domain}'.`);
                }
                if (create || (b && b.hasChild(p))) {
                    return b.child(p);
                }
            }, bundle);
        }
        return bundle;
    }
    container(domain, resolver = new CustomProvider_1.default()) {
        const bundle = this.bundle(domain, false);
        if (!bundle) {
            (0, Logger_1.error)(`There is no bundle to domain '${domain}'.`);
        }
        return new Container_1.default(bundle, resolver);
    }
}
exports.default = OdinCore;
//# sourceMappingURL=OdinCore.js.map